// extracted by css-extract-rspack-plugin
export default {"buttons":"MgFpY7VvNlI5X0Zp"};